import { atom } from "recoil"

export const AtomBirthdayConverted = atom({
    key:'ATOMBIRTHDAYCONVERTED',
    default:''
})
  